import React, { Component } from "react";
import PropTypes from "prop-types";
import { GridRow, GridColumn } from "arv-reactcomponents";
import VerticalCarousel from "../VerticalCarousel";
import HorizontalCarousel from "../HorizontalCarousel";

class ShopAllStylesCarousels extends Component {
  constructor() {
    super();
    this.state = {
      activeIndex: 0,
    };
    this.buttonAction = this.buttonAction.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    const { index } = nextProps;
    if (index !== this.state.activeIndex) {
      this.setState({ activeIndex: nextProps.index }); //eslint-disable-line
    }
  }
  get verticalImages() {
    const { data } = this.props;
    return data && data.map(item => item && item.thumbnail);
  }
  get horizontalImages() {
    const { data } = this.props;
    return data && data.map(item => item && item.large);
  }
  get prevButtonDisabled() {
    return this.state.activeIndex === 0;
  }
  get nextButtonDisabled() {
    const { data } = this.props;
    return this.state.activeIndex === data.length - 1;
  }
  get showCarousel() {
    return this.props.data.length > 1;
  }
  buttonAction(value) {
    const { activeIndex } = this.state;
    if (value === "next") {
      const newIndex = activeIndex + 1;
      this.setState({ activeIndex: newIndex });
    } else if (value === "prev") {
      const newIndex = activeIndex - 1;
      this.setState({ activeIndex: newIndex });
    } else {
      this.setState({ activeIndex: value });
    }
  }

  render() {
    const { activeIndex } = this.state;
    return (
      <GridRow className="nw-shopallstylescarousel-container">
        <GridColumn className="nwc-grid-col-sm-3">
          <VerticalCarousel.component
            data={this.verticalImages}
            buttonAction={this.buttonAction}
            activeIndex={activeIndex}
            prevButtonDisabled={this.prevButtonDisabled}
            nextButtonDisabled={this.nextButtonDisabled}
            showCarousel={this.showCarousel}
          />
        </GridColumn>
        <GridColumn className="nwc-grid-col-sm-9">
          <HorizontalCarousel.component
            data={this.horizontalImages}
            buttonAction={this.buttonAction}
            activeIndex={activeIndex}
            prevButtonDisabled={this.prevButtonDisabled}
            nextButtonDisabled={this.nextButtonDisabled}
            showCarousel={this.showCarousel}
          />
        </GridColumn>
      </GridRow>
    );
  }
}

ShopAllStylesCarousels.propTypes = {
  data: PropTypes.shape([]).isRequired,
  index: PropTypes.number.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ShopAllStylesCarousels,
  component: ShopAllStylesCarousels,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ShopMultiple/ShopAllStylesCarousels/index.js